import script from "./RechnungCategoryTwo.vue?vue&type=script&setup=true&lang=js"
export * from "./RechnungCategoryTwo.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/objects/RechnungCategoryTwo.css?vue&type=style&index=0&id=0bbaea4b&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bbaea4b"]])

export default __exports__